import {contentStudioPricingModalActions} from '@/stores/contentStudioPricingModalStore';

const openContentStudioPricingModal = (
  source?: string,
  callbacks?: {
    onCancelCallback?: () => void;
    onSuccessCallback?: () => void;
  }
) => {
  contentStudioPricingModalActions.openUpgradeModal({
    source,
    onCancelCallback: callbacks?.onCancelCallback,
    onSuccessCallback: callbacks?.onSuccessCallback,
  });
};

export default openContentStudioPricingModal;
